// DriversMenu.jsx - Updated Design
import { Truck, UserPlus, UserX, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";


function DriversMenu() {
  const navigate = useNavigate();
  const driverActions = [
    { 
      id: "portal", 
      label: "Driver Portal", 
      icon: Truck, 
      description: "View driver orders and deliveries",
      color: "from-blue-500 to-cyan-500",
      bgColor: "from-blue-50 to-cyan-50",
      borderColor: "border-blue-200",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600"
    },
    { 
      id: "add", 
      label: "Add Driver", 
      icon: UserPlus, 
      description: "Add a new driver to the system",
      color: "from-green-500 to-emerald-500",
      bgColor: "from-green-50 to-emerald-50",
      borderColor: "border-green-200",
      iconBg: "bg-green-100",
      iconColor: "text-green-600"
    },
    { 
      id: "deactivate", 
      label: "Deactivate Driver", 
      icon: UserX, 
      description: "Deactivate an existing driver",
      color: "from-red-500 to-pink-500",
      bgColor: "from-red-50 to-pink-50",
      borderColor: "border-red-200",
      iconBg: "bg-red-100",
      iconColor: "text-red-600"
    }
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8 md:mb-12">
         <button
          onClick={() => navigate("/admin")}
          className="group flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-all mb-6 font-medium text-sm md:text-base"
          style={{ fontFamily: "Bambino" }}
        >
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          <span>Back to Dashboard</span>
        </button>
        <h1
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center bg-gradient-to-r from-blue-600 via-cyan-500 to-green-500 bg-clip-text text-transparent"
          style={{ fontFamily: "Bambino", lineHeight: "1.2" }}
        >
          Driver Management
        </h1>
        <p
          className="text-center text-gray-600 text-sm md:text-base mt-3"
          style={{ fontFamily: "Bambino" }}
        >
          Manage your driver team efficiently
        </p>
      </div>

      {/* Action Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {driverActions.map((action) => {
          const Icon = action.icon;
          return (
            <button
              key={action.id}
              onClick={() => navigate(`/admin/drivers/${action.id}`)}
              className={`group relative bg-white/70 backdrop-blur-md rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 border-2 ${action.borderColor} overflow-hidden`}
            >
              {/* Gradient Background on Hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${action.bgColor} opacity-0 group-hover:opacity-50 transition-opacity duration-300 rounded-2xl md:rounded-3xl`}></div>

              <div className="relative flex flex-col items-center text-center space-y-4">
                {/* Icon Container */}
                <div className={`w-16 h-16 md:w-20 md:h-20 ${action.iconBg} rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-md`}>
                  <Icon className={`w-8 h-8 md:w-10 md:h-10 ${action.iconColor}`} />
                </div>

                {/* Title */}
                <h2
                  className="text-lg md:text-2xl font-bold text-gray-800 group-hover:bg-gradient-to-r group-hover:bg-clip-text group-hover:text-transparent transition-all"
                  style={{ fontFamily: "Bambino" }}
                >
                  {action.label}
                </h2>

                {/* Description */}
                <p
                  className="text-gray-600 text-xs md:text-sm group-hover:text-gray-700 transition-colors"
                  style={{ fontFamily: "Bambino" }}
                >
                  {action.description}
                </p>

                {/* Action Button */}
                <div className="mt-4 pt-4 border-t border-gray-200 w-full">
                  <div className={`inline-block bg-gradient-to-r ${action.color} text-white px-4 md:px-6 py-2 md:py-2.5 rounded-lg md:rounded-xl text-xs md:text-sm font-bold group-hover:shadow-lg transition-all`}>
                    Access Now
                  </div>
                </div>
              </div>

              {/* Decorative corner accent */}
              <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-br ${action.color} opacity-0 group-hover:opacity-5 rounded-bl-3xl transition-opacity duration-300`}></div>
            </button>
          );
        })}
      </div>

      {/* Info Box */}
      <div className="mt-12 bg-white/70 backdrop-blur-md rounded-2xl md:rounded-3xl p-6 md:p-8 border-2 border-purple-100 shadow-lg">
        <h3
          className="text-lg md:text-xl font-bold text-gray-800 mb-3 flex items-center gap-2"
          style={{ fontFamily: "Bambino" }}
        >
          <span className="inline-block w-2 h-2 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-full"></span>
          Quick Tips
        </h3>
        <ul className="space-y-2 text-sm md:text-base text-gray-700" style={{ fontFamily: "Bambino" }}>
          <li>• Use <strong>Driver Portal</strong> to monitor real-time delivery status and driver locations</li>
          <li>• <strong>Add Driver</strong> when you have new team members joining your delivery fleet</li>
          <li>• Use <strong>Deactivate Driver</strong> to remove access for drivers who are no longer active</li>
        </ul>
      </div>
    </div>
  );
}

export default DriversMenu;